// extracted by mini-css-extract-plugin
export var closeButton = "_py-2";
export var closeButtonIcon = "_py-3";
export var lightboxContent = "_py-1";
export var lightboxOverlay = "_py-0";